import { AnalyticsService } from './analytics.service'
import { AppointmentTypesService } from './appointment-types.service'
import { AuthService } from './auth.service'
import { AvailabilityService } from './availability.service'
import { BillingService } from './billing.service'
import { createBookingAnalyticsService } from './booking-analytics.service'
import { CalendarsService } from './calendars.service'
import { CancellationPolicyService } from './cancellation-policy.service'
import { ConfirmationService } from './confirmation.service'
import { ConnectedAppsService } from './connected-apps.service'
import { CustomOffsetsService } from './custom-offsets.service'
import { EventsService } from './events.service'
import { publicHttpClient } from './http-client'
import { LateCancelsService } from './late-cancels.service'
import { MeetLinksService } from './meet-links.service'
import { MessageTemplatesService } from './message-templates.service'
import { PhoneStandingConsentsService } from './phone-standing-consents.service'
import { PreferencesService } from './preferences.service'
import { ProfileService } from './profile.service'
import { SmsComplianceService } from './sms-compliance.service'
import { TestRemindersService } from './test-reminders.service'
import { UserEventsService } from './user-events.service'

export type ServerResponse<T> = {
  data: T
}

const BookingAnalyticsService = createBookingAnalyticsService(publicHttpClient, import.meta.env.VITE_API_URL)

export const ApiService = {
  Analytics: AnalyticsService,
  BookingAnalytics: BookingAnalyticsService,
  AppointmentTypes: AppointmentTypesService,
  Auth: AuthService,
  Availability: AvailabilityService,
  Billing: BillingService,
  Calendars: CalendarsService,
  CancellationPolicy: CancellationPolicyService,
  Confirmation: ConfirmationService,
  ConnectedApps: ConnectedAppsService,
  CustomOffsets: CustomOffsetsService,
  Events: EventsService,
  LateCancels: LateCancelsService,
  MeetLinks: MeetLinksService,
  MessageTemplates: MessageTemplatesService,
  PhoneStandingConsents: PhoneStandingConsentsService,
  Preferences: PreferencesService,
  Profile: ProfileService,
  SmsCompliance: SmsComplianceService,
  TestReminders: TestRemindersService,
  UserEvents: UserEventsService,
}
